import { Component, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import swal from 'sweetalert2';
import { ExcelService } from 'src/app/core/services/excel.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-top-ten-flop-ten',
  templateUrl: './top-ten-flop-ten.component.html',
  styleUrls: ['./top-ten-flop-ten.component.css'],
})
export class TopTenFlopTenComponent implements OnInit {

  constructor(
    private _service: AppService,
    private toastrService: ToastrService,
    private loadingBar: LoadingBarService,
    private excelService: ExcelService,
    private _router: Router,
    private storage: LocalStorageService
  ) { }
  key = 'matricule';
  reverse = false;
  p = 1;
  filter: string;
  // tslint:disable-next-line: member-ordering
  topTens: any;
  flopTens: any;
  tensLength = 0;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  ngOnInit() {
    this.getAllTen();
  }

  exporterFicheTopTen() {
    this.loadingBar.start();
    const arrayTauxExecution = [];
    for (let i = 0; i < this.topTens?.length; i++) {
      arrayTauxExecution.push(
        {
          'Matricule': this.topTens[i].matricule,
          'Qualite': this.topTens[i].qualite,
          'Nom': this.topTens[i].nom,
          'Prénoms': this.topTens[i].prenoms,
          'Note': this.topTens[i].note,
        }
      );
    }
    this.excelService.exportAsExcelFile(arrayTauxExecution, 'top_ten');
    this.loadingBar.stop();
  }

  exporterFicheFlopTen() {
    this.loadingBar.start();
    const arrayTauxExecution = [];
    for (let i = 0; i < this.flopTens?.length; i++) {
      arrayTauxExecution.push(
        {
          'Matricule': this.flopTens[i].matricule,
          'Qualite': this.flopTens[i].qualite,
          'Nom': this.flopTens[i].nom,
          'Prénoms': this.flopTens[i].prenoms,
          'Note': this.flopTens[i].note,
        }
      );
    }
    this.excelService.exportAsExcelFile(arrayTauxExecution, 'flop_ten');
    this.loadingBar.stop();
  }

  getAllTen() {
    this.loadingBar.start();
    this._service.getData('reporting/' + this.storage.retrieve('idCampagneEiaSelected') + '/top-flop')
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.loadingBar.stop();
            this.topTens = res.data.topten;
            this.flopTens = res.data.flopten;
            this.tensLength = res.data.total;
          } else {
            swal.fire({
              title: 'HR PERF',
              type: 'warning',
              text: res.message,
              showCancelButton: false,
              confirmButtonText: 'ok',
            });
            this.loadingBar.stop();
          }
        },
        (err) => {
          this.toastrService.error(err.error.message);
          this.loadingBar.stop();
        }
      );
  }
}
